import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-paymentstatus',
  templateUrl: './paymentstatus.component.html',
  styleUrls: ['./paymentstatus.component.css']
})
export class PaymentstatusComponent implements OnInit {

  paymentDetails : any ;
  paymenttrueorfalls : boolean = false;
  status :string = "";

  constructor(private router: Router) { }
  ngOnInit() {
    this.paymentDetails = JSON.parse(localStorage.getItem('paymentDetails') || '{}');
    this.paymenttrueorfalls = true;
    const urlParams = new URLSearchParams(window.location.search);
    const status = urlParams.get('status'); 
    if (this.paymentDetails) {
    } else {
    }
    if (status) {

      if (status === '1') {
        this.status = 'Payment Success';
      } else if (status === '0') {
        this.status = 'Payment Failed';
      } else if (status === '2') {
        this.status = 'Payment Cancelled';
      }
    } else {
    }
    setTimeout(() => {
       this.router.navigate([`/Dashboard/PaymentHistory`]);
    }, 5000);
  }
  paymentStatus: string = ' ';

  setPaymentSuccessful() {
    this.paymentStatus = 'successful';
  }

  setPaymentFailed() {
    this.paymentStatus = 'failed';
  }

  setPaymentCancelled() {
    this.paymentStatus = 'cancelled';
  }
  downloadReceipt() {
    const receiptContent = `
      Payment Receipt:
      -----------------
      First Name: ${this.paymentDetails.first_name}
      Email: ${this.paymentDetails.email}
      Mobile: ${this.paymentDetails.mobile}
      Transaction ID: ${this.paymentDetails.txnid}
      Plan Name: ${this.paymentDetails.plan_name}
      Amount: ${this.paymentDetails.amount}
      Service Provider: ${this.paymentDetails.service_provider}
      Status: ${this.status}
    `;
  
    const blob = new Blob([receiptContent], { type: 'text/plain' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = 'payment_receipt.txt';
    link.click();
  }
  
}
